// JsonArrayUtility.js

class JsonArrayUtility {
    static findValueBySearchKey(array, searchKey, searchValue, resultKey) {
      // Your implementation to find the value in the array
      // ...
  
      // For example, let's assume the array is an array of objects
      const foundItem = array.find(item => item[searchKey] === searchValue);
  
      // Return the resultKey of the found item
      return foundItem ? foundItem[resultKey] : null;
    }
  }
  
  export default JsonArrayUtility;
  